import styled from "styled-components";
import bg from "../assets/img/nmixx.png";
import aws from "../assets/img/new/aws.svg";
import { media } from "./lib/styles/media";
import { motion } from "framer-motion";
import { customChildVariants, customVariants } from "./lib/styles/animation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderOpen, faHashtag } from "@fortawesome/free-solid-svg-icons";
import Bold from "./common/Bold";
import useOnceObserver from "./lib/hook/useOnceObserver";

const Section = styled.section`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  align-items: center;
  position: relative;
  scroll-snap-align: start;
  /* background: url(${bg}); */
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: center;
  padding: 50px 0px;

  ${media.phone`
    padding: 20px;
  `}
`;

const TopBox = styled(motion.div)``;

const TitleBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 50px;

  ${media.phone`
    font-size: 25px;
    margin-bottom: 20px;
  `}
`;

const Title = styled.div`
  font-size: 40px;
  font-family: "S-CoreDream-9BLACK";
  color: #fff;
  text-shadow: 1px 1px 25px #000;
  user-select: none;
  cursor: pointer;

  ${media.phone`
    font-size: 23px;
  `}
`;

const BottomBox = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1100px;
  gap: 30px;

  ${media.phone`
    width: 100%;
    gap: 20px;
  `}
`;

const Item = styled(motion.div)`
  width: 100%;
  padding: 20px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
  color: #fff;
`;
// const ItemLogo = styled.img`
//   width: 75px;
//   filter: brightness(0);
//   margin-bottom: 5px;
// `

const ItemTitleBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 0.8rem;

  ${media.phone`
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    margin-bottom: 0.6rem;
  `}
`;

const ItemTitleLeft = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;

  ${media.phone`
    gap: 5px;
  `}
`;

const ItemTitle = styled.div`
  font-size: 25px;
  font-family: "S-CoreDream-6Bold";

  ${media.phone`
    font-size: 18px;
  `}
`;

const ItemDate = styled.div`
  font-size: 15px;
  font-family: "S-CoreDream-3Light";

  ${media.phone`
    font-size: 12px;
  `}
`;

const ItemDepartmentBox = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 15px;

  ${media.phone`
    font-size: 14px;
    align-items: flex-start;
    flex-wrap: wrap;
  `}
`;

const Department = styled.div`
  padding: 5px 10px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #fff;
  user-select: none;
  font-family: "S-CoreDream-3Light";
  display: flex;
  align-items: center;
  border-radius: 20px;
`;

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  /* padding: 3px 6px; */
  /* border-radius: 3px; */
`;

const ItemContent = styled.ul`
  font-size: 15px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
  padding: 0.8rem;
  border-radius: 8px;
  line-height: 1.7;
  font-family: "S-CoreDream-3Light";
  margin: 0;

  ${media.phone`
    font-size: 14px;
  `}
`;

const ItemSkillContainer = styled.div`
  display: flex;
  gap: 5px;
  font-family: "S-CoreDream-3Light";

  ${media.phone`
    flex-wrap: wrap;
  `}
`;

const ItemSkillBox = styled.div`
  position: relative;
  display: flex;
  cursor: pointer;
`;

const ItemSkillInfoBox = styled.div`
  position: absolute;
  display: none;
  font-size: 14px;
  font-weight: 600;
  background-color: #333333c1;
  padding: 5px 10px;
  color: #fff;
  white-space: nowrap;
  top: 165%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;

  ${ItemSkillBox}:hover & {
    display: flex;
  }
`;

const ItemSkill = styled.img`
  height: 28px;
  width: 28px;
  object-fit: cover;
  border-radius: 3px;

  ${media.phone`
    height: 24px;
  `}
`;

const ItemSkillImage = styled.img`
  background-color: #232f3e;
  height: 28px;
  width: 28px;
  object-fit: cover;
  border-radius: 3px;

  ${media.phone`
    height: 24px;
    width: 26px;
  `}
`;

const ItemList = styled.li`
  padding-left: 5px;
  margin-left: 20px;

  ${media.phone`
    padding-left: 5px;
    margin-left: 15px;
  `}
`;

// 경력
export default function Career() {
  const { ref, animation } = useOnceObserver();
  return (
    <Section id="career">
      {/* 상단박스 */}
      <TopBox ref={ref} animate={animation} variants={customChildVariants}>
        <TitleBox>
          <Title title="서울소프트">
            <FontAwesomeIcon icon={faFolderOpen} /> CAREER & CERTIFICATE
          </Title>
        </TitleBox>
      </TopBox>
      <BottomBox ref={ref} animate={animation} variants={customVariants}>
        <Item variants={customChildVariants}>
          {/* <ItemLogo src={seoulsoft} /> */}
          <ItemTitleBox>
            <ItemTitleLeft>
              <ItemTitle>이로운소프트</ItemTitle>
              <ItemDate>2025.12 ~ 2026.03</ItemDate>
            </ItemTitleLeft>
            <ItemSkillContainer>
              <ItemSkillBox>
                <ItemSkill
                  src="https://img.shields.io/badge/-F7DF1E?style=flat&logo=javascript&logoColor=white"
                  alt="JavaScript"
                />
                <ItemSkillInfoBox>JavaScript</ItemSkillInfoBox>
              </ItemSkillBox>
              <ItemSkillBox>
                <ItemSkill
                  src="https://img.shields.io/badge/-339933?style=flat&logo=nodedotjs&logoColor=white"
                  alt="Nodejs"
                />
                <ItemSkillInfoBox>Node.js</ItemSkillInfoBox>
              </ItemSkillBox>
            </ItemSkillContainer>
          </ItemTitleBox>
          <ItemDepartmentBox>
            <Department>
              <StyledFontAwesomeIcon
                icon={faHashtag}
                style={{ marginRight: "5px" }}
              />
              SI 개발팀
            </Department>
            <Department>
              <StyledFontAwesomeIcon
                icon={faHashtag}
                style={{ marginRight: "5px" }}
              />
              프론트엔드
            </Department>
          </ItemDepartmentBox>
          <ItemContent>
            <ItemList>
              <Bold>ERP</Bold> 서비스 개발 <br />
            </ItemList>
            <ItemList>
              <Bold>VanillaJS</Bold>를 이용한 프론트엔드 개발 <br />
            </ItemList>
          </ItemContent>
        </Item>

        <Item variants={customChildVariants}>
          {/* <ItemLogo src={seoulsoft} /> */}
          <ItemTitleBox>
            <ItemTitleLeft>
              <ItemTitle>서울소프트</ItemTitle>
              <ItemDate>2024.04 ~ 2025.11</ItemDate>
            </ItemTitleLeft>
            <ItemSkillContainer>
              <ItemSkillBox>
                <ItemSkill
                  src="https://img.shields.io/badge/-092E20?style=flat&logo=django&logoColor=white"
                  alt="Django"
                />
                <ItemSkillInfoBox>Django</ItemSkillInfoBox>
              </ItemSkillBox>
              <ItemSkillBox>
                <ItemSkill
                  src="https://img.shields.io/badge/-0769AD?style=flat&logo=jquery&logoColor=white"
                  alt="jquery"
                />
                <ItemSkillInfoBox>JQuery</ItemSkillInfoBox>
              </ItemSkillBox>
              <ItemSkillBox>
                <ItemSkill
                  src="https://img.shields.io/badge/-4479A1?style=flat&logo=mysql&logoColor=white"
                  alt="mysql"
                />
                <ItemSkillInfoBox>MySQL</ItemSkillInfoBox>
              </ItemSkillBox>
              <ItemSkillBox>
                <ItemSkillImage src={aws} alt="aws" />
                <ItemSkillInfoBox>AWS EC2, RDS, S3</ItemSkillInfoBox>
              </ItemSkillBox>
            </ItemSkillContainer>
          </ItemTitleBox>
          <ItemDepartmentBox>
            <Department>
              <StyledFontAwesomeIcon
                icon={faHashtag}
                style={{ marginRight: "5px" }}
              />
              모빌리티 개발팀
            </Department>
            <Department>
              <StyledFontAwesomeIcon
                icon={faHashtag}
                style={{ marginRight: "5px" }}
              />
              풀스택
            </Department>
          </ItemDepartmentBox>
          <ItemContent>
            <ItemList>
              운수사 <Bold>ERP</Bold> 서비스 개발 <br />
            </ItemList>
            <ItemList>
              <Bold>Django</Bold> 기반 <Bold>MVT 패턴</Bold>을 활용한 웹 서비스
              개발 <br />
            </ItemList>
            <ItemList>
              <Bold>AWS</Bold> 를 이용한 서비스 배포 및 인프라 관리 <br />
            </ItemList>
          </ItemContent>
        </Item>

        {/* 자격증 */}
        <Item variants={customChildVariants}>
          {/* <ItemLogo src={seoulsoft} /> */}
          <ItemTitleBox>
            <ItemTitle>자격증</ItemTitle>
            {/* <ItemDate>2024.04 ~ (재직중)</ItemDate> */}
          </ItemTitleBox>
          <ItemContent>
            <ItemList>SQLD 자격증 (SQL Developer)</ItemList>
            <ItemList>KSTQB CTBL (Certified Tester Basic Level)</ItemList>
            <ItemList>DSAC 3급(프로그래머)</ItemList>
          </ItemContent>
        </Item>
      </BottomBox>
    </Section>
  );
}
